import React from 'react';
import { Table, TableBody, TableCell, TableHead, TableRow } from '@mui/material';
import { CEREBRUMX_MAX_SAMPLE_ROWS } from '../../constants';
import { formatCoordinates, formatMeasure } from './units';
import './cerebrumx.scss';

const TIME_FORMAT = 'h:mm:ss A';

/**
 * The breadcrumbs the device recorded between reported events, newest first
 * and capped (the full array stays in Raw JSON). Sample speeds are unitless
 * on the wire and borrow the payload's OBD speed unit.
 */
export const TelemetrySamplesTable = ({ samples, speedUnit, ctx }) => {
	const { t } = ctx;
	const label = (key, values) => t(`oemDataModal_cerebrumx_location_${key}`, values);
	const na = t('oemDataModal_notAvailable');
	const shown = [...samples].reverse().slice(0, CEREBRUMX_MAX_SAMPLE_ROWS);
	const withUnit = (measure) => measure && { ...measure, unit: measure.unit ?? speedUnit };
	const cell = (text) => text ?? na;

	return (
		<section className="oem-samples">
			<h3 className="oem-section-title">{label('samples')}</h3>
			<div className="oem-samples-scroll">
				<Table size="small">
					<TableHead>
						<TableRow>
							<TableCell>{label('time')}</TableCell>
							<TableCell>{label('coordinates')}</TableCell>
							<TableCell>{label('speed')}</TableCell>
							<TableCell>{label('accelerationShort')}</TableCell>
							<TableCell>{label('lateralShort')}</TableCell>
						</TableRow>
					</TableHead>
					<TableBody>
						{shown.map((sample, index) => (
							<TableRow key={`${sample.time ?? 'sample'}-${index}`}>
								<TableCell>{cell(sample.time && ctx.formatDateTime(sample.time, TIME_FORMAT))}</TableCell>
								<TableCell className="oem-mono">{cell(formatCoordinates(sample.latitude, sample.longitude))}</TableCell>
								<TableCell>{cell(formatMeasure(withUnit(sample.speed), ctx))}</TableCell>
								<TableCell>{cell(formatMeasure(sample.acceleration, ctx))}</TableCell>
								<TableCell>{cell(formatMeasure(sample.lateralAcceleration, ctx))}</TableCell>
							</TableRow>
						))}
					</TableBody>
				</Table>
			</div>
			{samples.length > shown.length && (
				<p className="oem-samples-caption">{label('showing', { shown: shown.length, total: samples.length })}</p>
			)}
		</section>
	);
};
